import { Box, Paper, Typography } from "@mui/material";
import { MovementTypes } from "constants/index";
import { calculateMovementTotals } from "helpers/movement";
import { useMemo } from "react";
import { Movement } from "types";

export function OperationPrintTotals({ movement }: { movement: Movement }) {
  const totals = useMemo(() => calculateMovementTotals(movement), [movement]);

  const shouldShowTotals =
    movement.movement_type_id !== MovementTypes.Transfer &&
    movement.movement_type_id !== MovementTypes.Additional;

  if (!shouldShowTotals) return null;

  return (
    <Paper
      sx={{
        border: "1px solid grey",
        p: 1,
        mt: 2,
        display: "flex",
        justifyContent: "flex-end",
      }}
    >
      <Box display="flex" gap={4}>
        <Typography variant="body2">
          <b>Cantidad Total:</b> {totals.totalCantidad}
        </Typography>
        <Typography variant="body2">
          <b>Total Unidad:</b> {totals.totalSubtotalUnidad}
        </Typography>
      </Box>
    </Paper>
  );
}